<template>
  <div>
    <header class="db-page-head">
      <div>
        <h2 class="db-page-title">Avisos emergentes</h2>
        <p class="db-page-subtitle">Imágenes que aparecen al entrar en la web los días que elijas.</p>
      </div>
      <div class="db-actions">
        <button type="button" class="db-btn" @click="showModal()">
          <span class="material-symbols-outlined">add</span> Nuevo aviso
        </button>
      </div>
    </header>

    <div v-if="loading" class="db-grid">
      <div v-for="n in 4" :key="n" class="db-skeleton" style="height: 260px"></div>
    </div>

    <div v-else-if="!lista.length" class="db-card db-empty">
      <span class="material-symbols-outlined">campaign</span>
      <p>No hay avisos creados.</p>
      <button type="button" class="db-btn db-btn--sm" @click="showModal()">Crear el primero</button>
    </div>

    <div v-else class="db-grid">
      <cardPopUp
        v-for="item in listaOrdenada"
        :key="item.id"
        :imageSrc="item.imagen"
        :popuptitle="item.titulo"
        :fechas="item.fechas"
        :url="item.url"
        :id="item.id"
        @editPopUp="editarPopUp"
        @eliminarPopUp="eliminarPopUp"
      />
    </div>

    <editorPopUp modalId="editorPopUp" :popUpData="popUpData" @actualizaLista="actualizaLista" />
  </div>
</template>

<script>
import axios from "@/directives/axios.js";
import editorPopUp from "@/components/dashboard/EditorPopUp.vue";
import cardPopUp from "@/components/dashboard/CardPopUp.vue";
import { confirmar, avisar, toISODate, avisarError } from "@/directives/dbDialogs.js";

export default {
  name: "PopUpControlEdit",
  components: { editorPopUp, cardPopUp },
  data() {
    return {
      lista: [],
      loading: true,
      popUpData: undefined,
    };
  },
  computed: {
    // Primero los que tienen fechas futuras, después los caducados
    listaOrdenada() {
      const hoy = toISODate(new Date());
      const proxima = (p) =>
        (p.fechas || "")
          .split(",")
          .map((f) => f.trim())
          .filter((f) => f >= hoy)
          .sort()[0] || "9999";
      return [...this.lista].sort((a, b) => (proxima(a) < proxima(b) ? -1 : 1));
    },
  },
  methods: {
    async eliminarPopUp(element) {
      const popup = this.lista.find((p) => p.id == element.id);
      const ok = await confirmar(this, `Se eliminará el aviso «${popup ? popup.titulo : ""}».`, {
        titulo: "Eliminar aviso",
        ok: "Eliminar",
        peligro: true,
      });
      if (!ok) return;
      try {
        const { data } = await axios.delete(`/popup/eliminarPopup?id=${element.id}`);
        this.actualizaLista(data.todosPopUp);
        avisar(this, `Se ha eliminado «${popup ? popup.titulo : "el aviso"}».`, "success", "Aviso eliminado");
      } catch (error) {
        avisarError(this, error, "No se pudo eliminar el aviso.");
      }
    },
    actualizaLista(elements) {
      this.lista = elements || [];
    },
    editarPopUp(data) {
      this.popUpData = this.lista.find((element) => element.id == data.id);
      this.$nextTick(() => this.$bvModal.show("editorPopUp"));
    },
    showModal() {
      this.popUpData = undefined;
      this.$nextTick(() => this.$bvModal.show("editorPopUp"));
    },
    async getPopUps() {
      try {
        const { data } = await axios.get("/popup/todosPopup");
        this.lista = data.todosPopUp || [];
      } catch (error) {
        avisarError(this, error, "No se pudieron cargar los avisos.");
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getPopUps();
  },
};
</script>
